module.exports = __webpack_public_path__ + "img/ico_menual05_on.a2351397.svg";